/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Cliche_Col_PhraseInputs */

const en_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const de_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const fr_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const es_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const it_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const nl_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const pl_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const fi_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const da_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const sv_keyword_optimizer_cliche_col_phrase = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

/**
* | output |
* | --- |
* | "Phrase" |
*
* @param {Keyword_Optimizer_Cliche_Col_PhraseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_cliche_col_phrase = /** @type {((inputs?: Keyword_Optimizer_Cliche_Col_PhraseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Cliche_Col_PhraseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "fr") return fr_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "es") return es_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "it") return it_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "nl") return nl_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "pl") return pl_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "fi") return fi_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "da") return da_keyword_optimizer_cliche_col_phrase(inputs)
	if (locale === "sv") return sv_keyword_optimizer_cliche_col_phrase(inputs)
	return en_keyword_optimizer_cliche_col_phrase(inputs)
});